// eslint-disable-next-line import/prefer-default-export
export enum FILTER_PARAMS {
  all = 'all',
  page = 'page'
}
